import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import './PersonalDevelopment.css';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const PersonalDevelopment = ({ employee, matrixCategories }) => {
  const flatCategories = matrixCategories.flat();
  const categoryRanks = Object.fromEntries(
    flatCategories.map((category, index) => [category, index + 1])
  );

  // 构建时间轴数据
  const timelineData = [
    { date: employee.id, category: employee.category }, // 初始状态
    ...employee.history || []
  ].sort((a, b) => new Date(a.date) - new Date(b.date));

  const data = {
    labels: timelineData.map(item => 
      new Date(item.date).toLocaleDateString('zh-CN')
    ),
    datasets: [
      {
        label: '发展轨迹',
        data: timelineData.map(item => categoryRanks[item.category || item.toCategory]),
        borderColor: '#36A2EB',
        tension: 0.3,
        pointBackgroundColor: '#36A2EB',
        pointRadius: 6,
      }
    ]
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: true,
        text: '个人发展轨迹'
      },
      tooltip: {
        callbacks: {
          label: (context) => {
            const index = context.dataIndex;
            const item = timelineData[index];
            return item.toCategory || item.category;
          }
        }
      }
    },
    scales: {
      y: {
        beginAtZero: false,
        ticks: {
          callback: (value) => {
            return flatCategories[value - 1] || '';
          }
        }
      }
    }
  };

  return (
    <div className="personal-development">
      <div className="development-chart">
        <Line data={data} options={options} />
      </div>
      <div className="development-timeline">
        <h3>发展历程详情</h3>
        <div className="timeline">
          {timelineData.map((item, index) => (
            <div key={index} className="timeline-item">
              <div className="timeline-date">
                {new Date(item.date).toLocaleDateString('zh-CN')}
              </div>
              <div className="timeline-content">
                <div className="timeline-category">
                  {item.toCategory || item.category}
                </div>
                {item.reason && (
                  <div className="timeline-reason">
                    {item.reason}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PersonalDevelopment; 